export default {
  createTask: '创建任务',
  createPianoTask: '创建钢琴任务',
  createWorkTask: '创建作业任务',
  createSmtOrder: '新增smt订单',
  colName: '任务名称',
  colDeviceName: '设备名称',
  colSn: '设备SN',
  colType: '类型',
  colStatus: '完成状态',
  colRunTime: '运行时间',
  colCreateTime: '创建时间',
  colAction: '操作',
  statusDone: '已完成',
  statusInProgress: '进行中',
  statusNotStarted: '未开始',
  typePiano: '弹钢琴',
  typeDance: '跳舞',
  typeSingDance: '载歌载舞',
  typeWork: '作业',

  labelTaskName: '任务名称',
  labelWorkRobot: '作业机器人',
  labelWorkDescription: '作业描述',
  placeholderWorkRobot: '请选择作业机器人',
  placeholderWorkDescription: '请填写作业描述',
  ruleWorkRobot: '请选择作业机器人',
  ruleWorkDescription: '请填写作业描述',
  ruleWorkDescriptionLength: '长度应为1到200',
  placeholderTaskName: '请填写任务名称',
  labelSong: '歌曲',
  placeholderSongRobot: '请选择歌曲机器人',
  placeholderSong: '请选择歌曲',
  labelDance: '舞蹈',
  placeholderDanceRobot: '请选择舞蹈机器人',
  placeholderDance: '请选择舞蹈',
  labelTaskStrategy: '任务策略',
  strategyImmediate: '立即执行',
  strategyTimed: '暂不执行',
  strategyDaily: '定时任务',
  labelSchedulePlan: '定时计划',
  placeholderScheduleTime: '请选择执行时间',
  cancel: '取消',
  confirm: '确认',
  danceBaseTest: '基础测试',

  ruleTaskNameRequired: '请填写任务名称',
  ruleTaskNameLength: '长度应为1到20',
  rulePianoRobot: '请选择钢琴机器人',
  ruleDanceRobot: '请选择跳舞机器人',
  ruleTaskType: '请选择任务类型',

  errSongOrDance: '请至少选择歌曲或舞蹈',
  errDailyNeedsSong: '定时任务需选择歌曲',
  errScheduleFields: '请选择执行时间',
  successCreate: '任务创建成功',
  failCreate: '任务创建失败',

  labelPickup: '下料点位',
  labelDelivery: '上料点位',
  labelTotalTrays: '料盘总数',
  labelPickupAreaCodes: '区位编号',
  placeholderPickup: '请填写下料导航点位，如 LM1',
  placeholderDelivery: '请填写上料导航点位，如 LM3',
  placeholderTotalTrays: '请填写本次订单要抓取的料盘总数',
  placeholderPickupAreaCodes: '请输入区位编号，多个以英文逗号隔开，如 4L,5L',
  rulePickup: '请填写下料点位',
  ruleDelivery: '请填写上料点位',
  ruleTotalTrays: '请填写料盘总数',
  rulePickupAreaCodes: '请填写区位编号',
  successCreateSmtOrder: 'SMT订单创建成功',
  failCreateSmtOrder: 'SMT订单创建失败',

  deleteButton: '删除',
  deleteConfirmTitle: '确定要删除该任务吗？',
  deleteSuccess: '任务删除成功',
  deleteFail: '任务删除失败',
  deleteConfirm: {
    title: '确认删除任务「{name}」吗？',
    content: '删除后不可恢复。',
    okText: '确认删除',
    cancelText: '取消',
  },
}
